/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgJavascript = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M7.282 17.354c.981 0 1.744-.264 2.29-.79.545-.528.818-1.264.818-2.208V7.18H6.76v.976l1.911.509v5.569c0 1.063-.54 1.595-1.622 1.595-.284 0-.603-.046-.956-.138s-.717-.22-1.093-.385v1.526c.293.165.642.294 1.045.385s.816.138 1.238.138zm7.865 0c1.174 0 2.086-.261 2.737-.784s.976-1.242.976-2.159c0-.696-.186-1.265-.557-1.705s-1.02-.83-1.946-1.168l-1.058-.385c-.633-.239-1.068-.454-1.307-.647s-.357-.44-.357-.742c0-.844.655-1.265 1.966-1.265.844 0 1.737.197 2.681.591V7.564c-.357-.174-.776-.312-1.258-.413S16.064 7 15.587 7c-1.136 0-2.035.254-2.695.763s-.99 1.203-.99 2.083c0 .642.19 1.185.571 1.63s1.015.832 1.904 1.161l1.045.386c.651.229 1.096.446 1.334.653s.358.47.358.79c0 .431-.19.77-.57 1.018s-.906.371-1.575.371c-.954 0-1.944-.202-2.97-.605v1.526c.229.11.518.209.866.296s.722.156 1.12.206.787.076 1.162.076z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgJavascript as Javascript };
